import { createContext } from 'react';
import type { DealRevenueModifiersState } from './types';

export const DealRevenueModifiersContext = createContext<DealRevenueModifiersState | null>(null);
